import { LitElement, html, nothing, type TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { label, type ShopItem } from './shop-types.ts';

/**
 * Kachel eines Artikels. Ein Klick führt in den Advantis-Shop (KaufLink) - eine
 * eigene Detailseite gibt es nicht mehr. Ohne KaufLink ist die Kachel nicht klickbar.
 */
@customElement('svgw-shop-tile')
export class SvgwShopTile extends LitElement {
    @property({ type: Object }) item: ShopItem | null = null;

    protected createRenderRoot(): HTMLElement {
        return this;
    }

    /** Wie alt: Zähler "(2)" am Ende des Namens weglassen - er unterschied nur gleichnamige Knoten. */
    private get displayTitle(): string {
        return (this.item?.name ?? '').replace(/\s*\(\d+\)$/, '');
    }

    protected render(): TemplateResult | typeof nothing {
        const item = this.item;
        if (item === null) {
            return nothing;
        }

        const content = html`
            <div class="shop-tile__image">
                ${item.imageUrl
                    ? html`<img src=${item.imageUrl} alt="" loading="lazy" class="img-fluid">`
                    : html`<div class="shop-tile__placeholder"><i class="fa-regular fa-file-lines"></i></div>`}
                ${item.kostenlos ? html`<span class="shop-tile__badge">${label('Shop.Free')}</span>` : nothing}
            </div>
            <div class="shop-tile__title">${this.displayTitle}</div>
        `;

        const tile = item.kaufLink
            ? html`<a class="shop-tile" href=${item.kaufLink} target="_blank" rel="noopener">${content}</a>`
            : html`<div class="shop-tile shop-tile--disabled">${content}</div>`;

        // Eigener Link unter der Kachel - Links dürfen nicht ineinander stecken.
        return item.ePaperUrl
            ? html`${tile}<a class="shop-tile__epaper" href=${item.ePaperUrl} target="_blank" rel="noopener"><i class="fal fa-book-open" aria-hidden="true"></i> ${label('Shop.EPaper')}</a>`
            : tile;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'svgw-shop-tile': SvgwShopTile;
    }
}
